import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';

import ImageSkeleton from '../../components/Skeleton/ImageSkeleton';

import GascoEstanques from '../../assets/images/estanques_ama.jpg';

import IcoRight from '../../assets/images/ico-right.svg';

import { getCasosExito } from '../../config/services/strapi/strapi';

import { CasoExito } from '../../interfaces/types';

function CasosExito() {
  const [cargando, setCargando] = useState(true);
  const [casosExito, setCasosExito] = useState<CasoExito[]>([]);

  useEffect(() => {
    const fetchCasosExito = async () => {
      setCargando(true);
      const rawCasosExito: any[] = await getCasosExito();

      if (!rawCasosExito.length) {
        console.error('No se encontraron casos de éxito');
        return;
      }

      const mappedCasosExito: CasoExito[] = rawCasosExito.map((caso: any) => ({
        id: caso.id,
        comuna: caso.comuna,
        descripcion: caso.descripcion,
        destacado: caso.destacado,
        imagenes: caso.imagenes ? caso.imagenes.map((img: any) => ({
          url: img.url
        })) : [],
        impactos: caso.impactos,
        nombre: caso.nombre,
        banner: {
          url: caso.banner?.url
        },
        portada: {
          url: caso.portada?.url
        },
        provincia: caso.provincia,
        region: caso.region,
        rubro: caso.rubro,
        slug: caso.slug,
        videoUrl: caso.video_url ? caso.video_url : undefined
      }));

      setCasosExito(mappedCasosExito);
      setCargando(false);
    };

    fetchCasosExito();
  }, []);

  return (
    <main>
      {/* Hero */}
      <section>
        <div className='flex flex-col lg:flex-row lg:items-center lg:flex-row-reverse lg:gap-x-2 border-b-[1px] border-[#ddd]'>
          <img
            className='w-full h-[300px] md:h-[551px] lg:w-[512px] lg:h-[368px] xl:w-[720px] 2xl:w-[1800px] xl:h-[547px] 2xl:h-[750px] lg:bg-center scale-100 object-cover z-10'
            src={GascoEstanques}
            alt='Casos de Éxito Gasco'
          />
          <div className="w-full lg:pl-[92px] lg:pr-[20px] xl:pr-[50px] py-[34px]">
            <h1 className='!text-[var(--text-color-primary)] pl-[15px] pr-[20px] !mt-0 !mb-[25.5px] !text-[20.4px] md:!text-[27.2px] lg:!text-[34px] xl:!text-[48px] xl:!font-[600] !leading-[24.48px] md:!leading-[32.64px] lg:!leading-[40.8px] xl:!leading-[57.6px]'>Descubre por qué muchas industrias de Chile eligen Gasco</h1>
          </div>
        </div>
      </section>
      {/* Casos de Éxito */}
      <section>
        <div className='px-[15px] lg:px-[92px] pt-[17px] pb-[59.5px] mt-[51px]'>
          <h2 className="!text-[var(--text-color-primary)] !text-[25.5px] md:!text-[34px] xl:!text-[48px] !font-[600] !leading-[30.6px] md:!leading-[40.8px] xl:!leading-[57px] text-center md:text-left lg:text-center !mb-[8.5px] !mt-0">
            Aprende sobre otras empresas como la tuya.
          </h2>
        </div>
        <div className='grid grid-cols-12 px-[15px] lg:px-[92px] pb-[59.5px] gap-4 2xl:gap-8'>
          {
            cargando ?

              Array.from({ length: 12 }).map((_, index) => (
                <div key={index} className="col-span-12 md:col-span-4">
                  <ImageSkeleton className="h-[395px] md:h-[235px] lg:h-[260px] xl:h-[400px]" />
                </div>
              ))

              :

              casosExito.map((caso: CasoExito, index: number) => (
                <NavLink
                  key={index}
                  to={`/casos-de-exito/${caso.slug}`}
                  className="col-span-12 md:col-span-4 w-full h-[395px] md:h-[235px] lg:h-[260px] xl:h-[400px] 2xl:h-[740px] relative !rounded-xl overflow-hidden z-50"
                >
                  <figure className='w-full h-full !m-0 !p-0'>
                    <img
                      className="w-full h-full object-cover"
                      src={caso.portada.url}
                      alt={caso.nombre}
                    />
                  </figure>
                  <div className="absolute bg-linear-to-b from-transparent to-black opacity-50 w-full h-full left-0 top-0 pointer-events-none z-10"></div>
                  <div className="absolute bottom-4 left-4 z-40 text-white">
                    <h2 className="!text-lg 2xl:!text-[26px] font-semibold 2xl:!font-normal mb-2 2xl:!mb-[24px] text-white">{caso.nombre}</h2>
                    <div className="w-8 h-8 rounded-full flex items-center justify-center group-hover:bg-transparent group-hover:text-transparent transition">
                      <img
                        src={IcoRight}
                        alt="Ver más"
                        className="w-16 h-16 group-hover:white"
                      />
                    </div>
                  </div>
                </NavLink>
              ))
          }
        </div>
      </section>
    </main>
  )
}

export default CasosExito
